import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, buildThumbnailUrl, Image } from '@bd/bdcore-utilities';
import VideoModal from './VideoModal';
import { typography, colors } from '../styles';

const styles = css `
  padding: 40px 0;
  margin: 0 0 0 0;
  @media(min-width: 992px) {
    padding: 70px 0;
  }
  @media(min-width: 1300px) {
    padding: 90px 0;
  }

  .ContentBanner_wrapper {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    @media(min-width: 992px) {
      flex-direction: row;
    }
  }

  .ContentBanner_title {
    display: block;
    width: 100%;
    font-family: ${typography.Serif};
    font-weight: 400;
    font-style: italic;
    font-size: 28px;
    color: ${colors.color1};
    letter-spacing: .5px;
    -webkit-background-clip: text;
    text-align:left;
    @media(min-width: 768px) {
      font-size: 30px;
    }
    @media(min-width: 992px) {
      font-size: 30px;
    }
    @media(min-width: 1200px) {
      font-size: 35px;
    }
    &:after {
      content: '';
      display: block;
      width: 75px;
      height: 3px;
      background-color ${colors.color2Light};
      margin: 20px 0 15px 0;
    }
  }
  .ContentBanner_titleAlt {
    display: block;
    width: 100%;
    font-family: ${typography.SansSerif};
    font-weight: 300;
    font-size: 24px;
    color: ${colors.color1};
    letter-spacing: 0;
    background: -webkit-linear-gradient(#C7BD8C, #9F8B54);
    -webkit-background-clip: text;
    @media(min-width: 768px) {
      font-size: 30px;
    }
    @media(min-width: 992px) {
      font-size: 35px;
    }
    @media(min-width: 1200px) {
      font-size: 40px;
    }
  }
  .ContentBanner_lead {
    p {
      font-weight: 300;
      font-size: 18px;
      letter-spacing: 0;
      line-height: 30px;
      padding: 0;
      @media(min-width: 992px) {
        font-size: 22px;
        line-height: 26px;
        padding: 0 30px 15px 0;
      }
      @media(min-width: 1100px) {
        font-size: 24px;
        line-height: 35px;
        padding: 0 30px 15px 0;
      }
    }
  }
  .ContentBanner_leadAlt {
    display: block;
    p {
      font-weight: 300;
      font-size: 18px;
      color: ${colors.color5};
      letter-spacing: 0;
      line-height: 25px;
      padding: 10px 15px;
      @media(min-width: 992px) {
        font-size: 22px;
        line-height: 30px;
        padding: 0 5%;
      }

      @media(min-width: 1400px) {
        padding: 0 5%;
        font-size: 24px;
        font-weight: 200;
        line-height: 40px;
      }
    }
    ul{
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      max-width: 100%;
      align-items: center;
      justify-content: center;
      padding-left: 0;
      li{
        color: ${colors.color4};
        background-color: white;
        padding: 10px 25px;
        margin: 5px;
        border-top: 7px solid ${colors.color1};
        @media(max-width: 768px){
          width: 100%;
        }
        p{
          margin-bottom: 0;
          text-align:center;
        }
      }
    }
  }
  .ContentBanner_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 25px 0 0 0;
    @media(min-width: 992px) {
      padding: 0 40px 0 0;
    }
  }
  .ContentBanner_image {
    width: 100%;
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }
  .VideoModal_wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
  .BackgroundImage{
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .ContentBanner_btn{
    margin: 10px auto 20px auto;
  }
`;

function ContentBanner({ title, lead, image, video, btn, subtitle }) {
  return (
    <div className={`${styles} ${!video ? 'ContentBanner_alt' : ''}`}>
      <div className="container">
        <div className="ContentBanner_wrapper">
          {
            video &&
            <div className="col-lg-6 order-lg-1 px-0">
              <VideoModal video={video}>
                <Image
                  src={image}
                  alt={title}
                  className="ContentBanner_image"
                  width={639}
                  height={337}
                  exact
                />
              </VideoModal>
            </div>
          }
          {
            image && !video &&
            <div className="BackgroundImage col-lg-6 order-lg-1 px-0" style={{ backgroundImage: `url('${buildThumbnailUrl(image, { width: 1200, height: 1200 })}')` }} />
          }
          <div className={`ContentBanner_content ${video || (image && !video) ? 'col-lg-6' : 'col-lg-12'}`}>
            {
              title &&
              <h2 className={video || (image && !video) ? 'ContentBanner_title' : 'ContentBanner_titleAlt text-center'}>{title}</h2>
            }
            {
              subtitle &&
              <h5 className={video || (image && !video) ? 'ContentBanner_title Underdog_left' : 'ContentBanner_titleAlt Underdog_center text-center'}>{subtitle}</h5>
            }
            {
              lead &&
              <div className={video || (image && !video) ? 'ContentBanner_lead' : 'ContentBanner_leadAlt text-center'} dangerouslySetInnerHTML={SanitizeHtml(lead)} />
            }
            {
              btn && btn.map(item => (
                <a className="Btn Gold ContentBanner_btn" href={item.file.contentUrl} target="_blank" rel="noopener noreferrer" key={item.button_text}>{item.button_text ? item.button_text : 'Download Now'}</a>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

ContentBanner.propTypes = {
  title: PropTypes.string,
  lead: PropTypes.string,
  image: PropTypes.string,
  video: PropTypes.string,
  btn: PropTypes.arrayOf(PropTypes.object),
  subtitle: PropTypes.string,
};

ContentBanner.defaultProps = {
  title: undefined,
  lead: undefined,
  video: null,
  image: null,
  btn: undefined,
  subtitle: undefined,
};

export default ContentBanner;



// WEBPACK FOOTER //
// ./src/components/ContentBannerWithButton.js